'use client';

import { useCachedImage } from '@/hooks/image/use-cached-image';
import {
  WsrvImage,
  type WsrvImageProps,
} from '@/components/ui/media/wsrv-image';

export type CachedWsrvImageProps = Omit<WsrvImageProps, 'src'> & {
  src: string;
  cacheOptions?: {
    enabled?: boolean;
    prefetch?: 'off' | 'idle';
    activateCacheRead?: boolean;
    preferCacheRead?: boolean;
  };
};

function isCacheEligibleSource(src: string) {
  return !(src.startsWith('blob:') || src.startsWith('data:'));
}

export function CachedWsrvImage({
  src,
  cacheOptions,
  transparencyFallbackSrc,
  ...props
}: CachedWsrvImageProps) {
  const { src: cachedSrc } = useCachedImage(src, {
    enabled: cacheOptions?.enabled ?? isCacheEligibleSource(src),
    prefetch: cacheOptions?.prefetch ?? 'off',
    activateCacheRead: cacheOptions?.activateCacheRead ?? true,
    preferCacheRead: cacheOptions?.preferCacheRead ?? false,
  });

  return (
    <WsrvImage
      src={cachedSrc ?? src}
      transparencyFallbackSrc={transparencyFallbackSrc ?? src}
      {...props}
    />
  );
}
